import FlexSearch from 'flexsearch';
import { create } from 'zustand';
import * as Obj from '@pkg/utils/objects';
import * as Str from '@pkg/utils/strings';

const InitialIndex = new FlexSearch.Index({
  tokenize: 'forward',
  context: true,
});

/**
 * @param {Index} index
 * @param {Map} map
 * @returns {Index}
 */
const updateIndex = (index, map) => {
  if (!Obj.isEmpty(index.register)) {
    for (const key in index.register) {
      if (!map.has(key)) {
        index.remove(key);
      }
    }
  }

  map.forEach(({ title }, key) => {
    if (!index.register?.[key]) {
      index.add(key, title);
    }
  });

  return index;
};

/**
 * @param {Object[]} roles
 * @param {Index} index
 * @returns {Object}
 */
export const storeRoles = (roles, index = InitialIndex) => {
  const map = new Map();
  const titles = {
    default: new Map(),
    lower: new Map(),
  };

  // Creates a map using a hash id from the title stores all role
  // uuids that share the same name in an ids array.
  const list = roles?.list ?? Object.values(roles ?? {});
  list.forEach((item) => {
    const id = item.uuid;
    const title = item.title;

    // For now we're hashing the titles for a simple id but this will be
    // replaced in the future with a role library.
    const hashId = Str.hash(title);

    if (map.has(hashId)) {
      map.get(hashId).ids.add(id);
      return;
    }

    map.set(hashId, {
      hashId,
      ids: new Set([id]),
      title,
    });
    titles.default.set(title, hashId);
    titles.lower.set(title.toLowerCase(), hashId);
  });

  return {
    index: updateIndex(index, map),
    list: [...map.values()].map((item) => item),
    map: map,
    titles: titles,
  };
};

/**
 * @type {Function}
 * @returns {any}
 */
const useStore = create((set) => ({
  index: InitialIndex,
  isLoading: true,
  list: [],
  map: new Map(),
  titles: {
    lower: new Map(),
    default: new Map(),
  },
  setLoading: (isLoading) => set(() => ({ isLoading })),
  setRoles: (list) => set(({ index }) => storeRoles(list, index)),
}));

export default useStore;
